import { FilterOptionModel } from '../../Filter/models/filter-option.model';
import { DateQueryModel } from '../../Forms/models/date-query.model';

export class SharedReportFilterModel {
    dateQueryFilter: DateQueryModel;
    nameFilterValues: string[];
    createdByFilterValues: string[];
    createdByFilterOptions: FilterOptionModel[];

    constructor(apiModel?: any) {
        if (apiModel) {
            this.dateQueryFilter = apiModel.dateQueryFilter;
            this.nameFilterValues = apiModel.nameFilterValues;
            this.createdByFilterValues = apiModel.createdByFilterValues;
            this.createdByFilterOptions = apiModel.createdByFilterOptions;
        }
    }
}
